import { axiosInstance } from './axiosInstance'
import * as constants from '../state/constants/apiConstants'
import SessionService from './session'

class TalkService {
	static saveConsulting(payload, config) {
		return axiosInstance
			.post(constants.TALK, payload, config)
			.then(resp => resp.data)
	}

	static getComments(payload, config) {
		return axiosInstance.get(
			constants.GET_TALK_COMMENTS +
				'?conferenceCmsId=' +
				payload.conferenceCmsId +
				'&page=' +
				payload.page +
				'&size=' +
				payload.size,
			config
		)
	}

	static setLikeComment(payload, config) {
		return axiosInstance
			.post(constants.TALK_COMMENT_LIKE, payload, config)
			.then(resp => resp.data)
	}

	static async getLikes(cmsId, eventId) {
		try {
			const config = {
				params: {
					conferenceCmsId: cmsId,
					event: eventId,
				},
				headers: {
					'Content-Type': 'application/json',
				},
			}
			if (SessionService.getIdTokenData() !== null) {
				config.headers.Authorization = SessionService.getIdTokenData()
			}

			const res = await axiosInstance.get(constants.GET_TALK_LIKES, config)
			return res.data
		} catch (e) {
			console.log('error setLike', e)
		}
	}

	static async setLike(payload) {
		try {
			const config = {
				headers: {
					'Content-Type': 'application/json',
				},
			}

			if (SessionService.getIdTokenData() !== null) {
				config.headers.Authorization = SessionService.getIdTokenData()
			}

			const res = await axiosInstance.post(
				constants.CONFERENCE_LIKE,
				payload,
				config
			)
			return res.data
		} catch (e) {
			console.log('error setLike', e)
		}
	}
}

export default TalkService
